
import Banner from '../components/Banner.vue'
import Modal from '../components/Modal.vue'
import { defineComponent, reactive, onMounted, toRefs } from "vue";
import axios from "axios";

export default defineComponent({
  
  components: {Banner, Modal},
  setup() {
    const state = reactive({
      conditions: Array,
      damageTypes: Array,
      magicSchools: Array,
      conditionalQuery: [],
    });

    onMounted(async () => {
      // Conditions
      const { data } = await axios.get(
        "https://www.dnd5eapi.co/api/conditions"
      );
      state.conditions = data.results;

      //   Damage Types
      const { data: damage } = await axios.get(
        "https://www.dnd5eapi.co/api/damage-types"
      );
      state.damageTypes = damage.results;

      //   Magic Schools
      const { data: magic } = await axios.get(
        "https://www.dnd5eapi.co/api/magic-schools"
      );
      state.magicSchools = magic.results;
    });

    const showCondition = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/conditions/${index}`
      );

      state.conditionalQuery = data;
    };

    const showDamage = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/damage-types/${index}`
      );

      state.conditionalQuery = data;
    };

    const showMagic = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/magic-schools/${index}`
      );

      state.conditionalQuery = data;
    };

    return { ...toRefs(state), showCondition, showDamage, showMagic };
  },
});
